import { render, staticRenderFns } from "./msg6.vue?vue&type=template&id=3fc3f964&"
import script from "./msg6.vue?vue&type=script&lang=js&"
export * from "./msg6.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports